import React from 'react';
import './RevenueChart.css';

const RevenueChart = ({ monthlyData = [] }) => {
  if (!monthlyData || monthlyData.length === 0) {
    return (
      <div className="revenue-chart">
        <h3>Receita Mensal</h3>
        <div className="empty-chart">
          <p>Nenhum dado de receita disponível</p>
        </div>
      </div>
    );
  }

  const maxRevenue = Math.max(...monthlyData.map(m => m.revenue), 1);

  const formatMonth = (monthStr) => {
    const [year, month] = monthStr.split('-');
    const date = new Date(year, month - 1);
    return date.toLocaleDateString('pt-BR', { month: 'short', year: '2-digit' });
  };

  return (
    <div className="revenue-chart">
      <h3>Receita Mensal</h3>

      <div className="chart-container">
        {monthlyData.map((data, index) => {
          const heightPercent = (data.revenue / maxRevenue) * 100;

          return (
            <div key={index} className="chart-bar-container">
              <div className="chart-bar-wrapper">
                <div
                  className="chart-bar"
                  style={{ height: `${heightPercent}%` }}
                  title={`R$ ${data.revenue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`}
                >
                  <div className="bar-value">
                    R$ {(data.revenue / 1000).toFixed(1)}k
                  </div>
                </div>
              </div>
              <div className="chart-label">
                <div className="month-label">{formatMonth(data.month)}</div>
                <div className="bookings-label">{data.bookings} reservas</div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="chart-legend">
        <div className="legend-item">
          <div className="legend-color" style={{ background: '#254544' }}></div>
          <span>Receita Mensal</span>
        </div>
      </div>
    </div>
  );
};

export default RevenueChart;
